import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExpandSimple2"><Path d="M12.5 18.5H18.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 11.5V5.5H11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconExpandSimple2;
